import PropTypes from 'prop-types'
import { LicenseTypes } from '../constants'

export const Licenses = ({
  label,
  type,
  limit,
  onTypeChange = () => {},
  onLimitChange = () => {},
  inputProps = {},
  ...otherProps
}) => {

  return (
    <div className="row" {...otherProps}>
      <label className="col-sm-4 col-lg-5 col-form-label">
        {label}
      </label>
      <div className="col-sm-8 col-lg-7">
        <div className="row">
          <div className="col-md-5 col-sm-6">
            <select className="form-control" onChange={onTypeChange}>
              <option disabled selected={!type}>Select Number of Licenses</option>
              <option value={LicenseTypes.Limited}>Custom limit</option>
              <option value={LicenseTypes.Unlimited}>Unlimited</option>
            </select>
          </div>

          {
            type ? (
              <div className="col-md-7 col-sm-6">
                <input
                  disabled={type === LicenseTypes.Unlimited}
                  value={limit}
                  type="number"
                  className="form-control"
                  placeholder="Enter number of licenses issued"
                  onChange={onLimitChange}
                  {...inputProps}
                />
              </div>
            ) : null
          }
        </div>
      </div>
    </div>
  )
}

Licenses.propTypes = {
  label: PropTypes.string,
  type: PropTypes.string,
  limit: PropTypes.number,
  onTypeChange: PropTypes.func,
  onLimitChange: PropTypes.func,
}
